// extracted by mini-css-extract-plugin
module.exports = {"root":"Messages_root__17oX2","header":"Messages_header__11i3K"};